import { PropsWithChildren } from "react";
import { Alert, Collapse } from "reactstrap";

interface Props {
  isOpen: boolean;
}

export function HelpCollapseArea({
  isOpen,
  children,
}: PropsWithChildren<Props>) {
  return (
    <Collapse isOpen={isOpen}>
      <Alert color="warning" fade={false}>
        {children}
      </Alert>
    </Collapse>
  );
}
